import React from 'react'
import { Image, Link } from 'newComponents'
import stars from '../../../images/static-stars.jpg'
import './styles.scss'

const BlogCard = (props) => {
  const { data, className, uid: slug } = props
  if (!data) return null
  const { title, featured_image: heroImage, categories, timestamp, hide_date: hideDate, author } = data

  // content checks
  const titleText = title?.text
  const primaryCategory = categories?.length > 0 ? categories[0] : ''
  const categoryUid = primaryCategory?.category?.uid
  const authorObject = author?.document?.data || {}
  const { author_name: authorName, author_image: authorImage } = authorObject
  const authorText = authorName?.text

  // data formatting
  const categoryUidToName = {
    podcast: 'Podcasts',
    'team-news': 'Team & News'
  }

  const formattedCategory = categoryUidToName[categoryUid] || categoryUid?.toUpperCase().replace(/-/g, ' ')
  const formattedtimestamp = timestamp?.toUpperCase()
  const showTimeStamp = timestamp && !hideDate

  return (
    <section className={`blog-post-card ${className}`}>
      <div className="blog-post-card-container">
        {/* GRID VARIANT (AUTHOR/CATEGORY PAGES) */}
        {className === 'grid-variant' || className === 'category-featured' ? (
          <>
            <Link to={`/blog/${slug}`} className="blog-post-card-image-container">
              <Image image={heroImage?.localFile || heroImage?.url || stars} className="image-box" />
            </Link>
            <div className="blog-post-card-text-container">
              {categoryUid && (
                <Link to={`/blog/category/${categoryUid}`} className="blog-post-card-category">
                  <span>{formattedCategory}</span>
                </Link>
              )}
              {titleText && (
                <Link to={`/blog/${slug}`} className="blog-post-card-title">
                  <span>{titleText}</span>
                </Link>
              )}
              <div className="blog-post-card-author-readtime">
                {/* show author pic if category featured */}
                {className === 'category-featured' && authorImage?.url && (
                  <Image className="blog-post-card-author-image" image={authorImage} />
                )}
                {authorText && (
                  <Link to={`/blog/author/${author.document.uid}`} className="blog-post-card-author">
                    {`By ${authorText}`}
                  </Link>
                )}
                {showTimeStamp && (
                  <>
                    <span className="blog-post-card-dot"> &nbsp; • &nbsp; </span>
                    <span className="blog-post-card-timestamp">{timestamp}</span>
                  </>
                )}
              </div>
            </div>
          </>
        ) : (
          // NORMAL VARIANT
          <div className="blog-post-card-text-container">
            {showTimeStamp && (
              <>
                <span className="blog-post-card-timestamp">{formattedtimestamp}</span>
                <span className="blog-post-card-dot"> &nbsp; • &nbsp; </span>
              </>
            )}
            {categoryUid && (
              <Link to={`/blog/category/${categoryUid}`} className="blog-post-card-category">
                <span>{formattedCategory}</span>
              </Link>
            )}
            {titleText && (
              <Link to={`/blog/${slug}`} className="blog-post-card-title">
                <span>{titleText}</span>
              </Link>
            )}
            {(timestamp || authorText) && (
              <div className="blog-post-card-author-readtime">
                {authorText && (
                  <Link to={`/blog/author/${author.document.uid}`} className="blog-post-card-author">
                    {`By ${authorText}`}
                  </Link>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </section>
  )
}
export default BlogCard
